import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const AssignBiz = () => {

    const [hpcList, setHpcList] = useState<any[]>([]);
    const [bizList, setBizList] = useState<any[]>([]);
    const [hpcBizList, setHpcBizList] = useState<any[]>([]);
    const [hpcId, setHpcId] = useState([]);
    const [bizId, setBizId] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        fetchCenterList();
    }, [])

        async function fetchCenterList() {
            setIsLoading(true);
            const centerResponse = await func.hpcBiz(null);
            setHpcBizList(Array.isArray(centerResponse) ? centerResponse : [])
            setIsLoading(false);
        }

    const filteredData = hpcBizList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const hpcNameRender = (rowData) => {
        return <span>{rowData.geoHPCName}</span>;
    };

    const bizNameRender = (rowData) => {
        return <span>{rowData.bizName}</span>;
    };

    async function newBiz() {
        setIsEdit(false)
        setOpenModal(true)
        setHpcId([])
        setBizId('')
        const response = await func.hpc(null);
        setHpcList(Array.isArray(response) ? response : [])
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateCenter();
            } else {
                const formData = new FormData();
                // formData.append("geographyId", stateId);
                // formData.append("districtId", districtId);
                formData.append("geoHPCId", JSON.stringify(hpcId));
                formData.append("bizUserId", bizId);

                const assign = api.AssignBizToHPC;
                fetch(assign, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                                    fetchCenterList();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })
            }
        }
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Assign Biz to HPC</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newBiz() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Assign Biz to Center">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="geoHPCName"
                                                header="Center Name"
                                                body={hpcNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="bizName"
                                                header="Biz User Name"
                                                body={bizNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                centered
                size="sm">
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Assign "} Biz to HPC</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Center</label>
                                <Select
                                    isMulti={!isEdit}
                                    value={Array.isArray(hpcList)
                                        ? hpcList
                                            .filter(hpc => hpcId.includes(hpc.geoHPCId))
                                            .map(hpc => ({
                                                value: hpc.geoHPCId,
                                                label: hpc.geoHPCName
                                            }))
                                        : []
                                    }
                                    onChange={async (selectedOptions) => {
                                        // const selectedIds = selectedOptions.map(option => option.value);
                                        const selectedIds = Array.isArray(selectedOptions)
                                            ? selectedOptions.map(option => option.value)
                                            : selectedOptions
                                                ? [selectedOptions.value]
                                                : [];
                                        setHpcId(selectedIds);
                                        const usrResponse = await func.listUsers();
                                        setBizList(Array.isArray(usrResponse) ? usrResponse : [])
                                    }}
                                    options={Array.isArray(hpcList)
                                        ? hpcList.map(hpc => ({
                                            value: hpc.geoHPCId,
                                            label: hpc.geoHPCName
                                        }))
                                        : []
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Biz</label>
                                <Select
                                    value={bizList.find(biz => biz.userId === bizId) ? {
                                        value: bizId,
                                        label: bizList.find(biz => biz.userId === bizId).userFirstName + " " +
                                            bizList.find(biz => biz.userId === bizId).userLastName
                                    } : null}
                                    onChange={async (e) => {
                                        setBizId(e.value);
                                    }}
                                    required
                                    placeholder="Select Biz"
                                    options={bizList.map(biz => ({
                                        value: biz.userId,
                                        label: biz.userFirstName + " " + biz.userLastName
                                    }))}>
                                </Select>
                            </div>
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    )
};

export default AssignBiz;